import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NotificationService } from '@services/notification.service';
import { dateOptions, notificationCenterItem, timeOptions } from '@shared/models/notificationcenter';
import { interval, Subscription } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

@Component({
	selector: 'app-floatingitem',
	templateUrl: './floatingitem.component.html',
	styleUrls: ['./floatingitem.component.scss'],
	animations: [
		trigger('inOutAnimation', [
			transition(':enter', [style({ opacity: 0 }), animate('.5s ease-out', style({ opacity: 1 }))]),
			// transition(
			//   ':leave',
			//   [
			//     style({ opacity: 1 }),
			//     animate('.2s ease-in',
			//       style({ opacity: 0, height: 0 }))
			//   ]
			// )
		]),
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class FloatingitemComponent implements OnInit, OnDestroy {
	private intervalSubscription: Subscription;

	@Input() public item: notificationCenterItem;
	@Input() public index: number;
	public formattedDate: string;
	public formattedTime: string;
	public age: number = 0;
	private identifier = uuidv4();

	constructor(private notificationService: NotificationService) {}

	ngOnInit(): void {
		this.formattedDate = new Intl.DateTimeFormat('da-DK', dateOptions).format(this.item.date).replace(/\./g, '/');
		this.formattedTime = new Intl.DateTimeFormat('da-DK', timeOptions).format(this.item.date).replace(/\./g, ':');

		this.intervalSubscription = interval(1000).subscribe((secondsPassed) => {
			this.age = secondsPassed + 1;
			console.log(`Floating notification ${this.identifier} is alive for ${secondsPassed}...`);
			if (this.age >= 5) {
				this.notificationService.removeFloatingNotification(this.index);

				// Only count the notification as *unread* if the user does not click it away within 5 seconds
				this.notificationService.addUnread();

				// Indicate to the user that the unread messages contain at least one error message
				if (this.item.type === 'error') {
					this.notificationService.setAlert(true);
				}
			}
		});
	}

	closeNotification() {
		this.notificationService.removeFloatingNotification(this.index);
	}

	ngOnDestroy() {
		console.log(`Destroy called on floating notification ${this.identifier}`);
		this.intervalSubscription.unsubscribe();
	}
}
